<template>
  <div class="white-card mbh">
    <div class="is-flex is-align-items-start is-justify-content-space-between is-flex-grow-1 mb-5 ml-4">
      <p class="is-size-3 has-text-weight-bold">
        {{ $t("af:application.kyc.video_appointment.modal.edit.title") }}
      </p>
      <button
        type="button"
        class="delete"
        @click="$emit('close')"/>
    </div>
    <p class="mb-5 mx-4">
      {{ $t("af:application.kyc.video_appointment.modal.edit.content") }}
    </p>
    <b-field :label="$t('af:application.kyc.video_appointment.modal.edit.field_label')" class="mb-5 mx-4">
      <b-datetimepicker
        v-model="appointment.startsAt"
        placeholder="Select a date"
        :timepicker="{
          incrementMinutes: 15,
          hourFormat: '24',
          minTime,
          maxTime
        }"
        :appendToBody="true"
        :horizontalTimePicker="true"
        :nearbyMonthDays="true"
        :datepicker="{ minDate }"
      />
    </b-field>
    <button class="button mx-4" @click="update">
      {{ $t("af:application.kyc.video_appointment.modal.edit.buttno.save") }}
    </button>
  </div>
</template>

<script>
import { dateToBackendOffsetDateTimeFormat } from '@/utils/util';
import i18n from "@/plugins/i18n";

export default {
  props: {
    appointmentProp: {
      type: Object,
      Required: false,
    }
  },
  data(){
    return {
      appointment: {
        startsAt: null,
      },
      minDate: null,
      minTime: new Date(),
      maxTime: new Date(),
    };
  },
  async created() {
    let now = new Date();
    let minutes = (Math.floor(now.getMinutes() / 15) * 15) % 60
    
    now.setMinutes(minutes + 15);
    now.setSeconds(0);
    now.setMilliseconds(0);

    this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    this.minTime.setHours(8, 0, 0, 0);
    this.maxTime.setHours(20, 0, 0, 0);
    
    this.appointment = this.appointmentProp;
    this.appointment.startsAt = new Date(this.appointment.startsAt);
  },
  methods: {
    update() {
      try {
        const request = {...this.appointment};
        request.startsAt = dateToBackendOffsetDateTimeFormat(request.startsAt);
        this.$store.dispatch("timeslot/updateById", {id: this.appointment.id, request: request});
        this.$emit('close');
        this.$buefy.toast.open({
          duration: 3000,
          message: i18n.t("af:application.kyc.video_appointment.modal.edit.toast.success"),
          position: "is-bottom",
          type: "is-success",
        });
      } catch {
        this.$buefy.toast.open({
          duration: 3000,
          message: i18n.t("af:application.kyc.video_appointment.modal.edit.toast.fail"),
          position: "is-bottom",
          type: "is-danger",
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.white-card {
  background: white;
  border-radius: 32px;
  padding: 48px;
  display: flex;
  flex-direction: column;
}

.button {
  width: fit-content;
}

@media only screen and (max-width: 792px) {
  .white-card {
    padding: 24px;
  }
}
</style>
